import React from "react";
import { Col, Row, Spin } from "antd";
import "./Loader.css";

export interface LoaderProps {
  loading: boolean;
}

const Loader = (props: LoaderProps) => {
  return props.loading ? (
    <Row
      justify="center"
      align="middle"
      style={{ height: "100%", width: "100%", backgroundColor: "#D3D3D3CC", zIndex: 10, position: "fixed" }}
    >
      <Col span={24}>
        <Row justify="center" align="middle" style={{ height: "100%" }}>
          <Spin tip="Loading..." size="large" />
        </Row>
      </Col>
    </Row>
  ) : null;
};

export default Loader;
